module.exports = __webpack_public_path__ + "static/media/wallet.e4193122.svg";